<template>
<div class="bottom-wrapper">
  <zcy-comp-labels></zcy-comp-labels>
  <div class="hr"></div>
  <div class="bottom-link-wrapper">
    <zcy-comp-links></zcy-comp-links>
    <div></div>
    <zcy-comp-wechat></zcy-comp-wechat>
  </div>
</div>
</template>
<script>
import CompLinks from './comp-links';
import CompWechat from './comp-wechat';
import CompLabels from './comp-labels';
export default {
  components: {
    'zcy-comp-links': CompLinks,
    'zcy-comp-wechat': CompWechat,
    'zcy-comp-labels': CompLabels
  }
};
</script>
<style scoped lang="less">
@import '../../assets/css/common.less';
.bottom-wrapper {
  width: 100%;
  min-width: @width-full;
  .bottom-bg;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // margin-top: 60px;
  // margin-top: 1px; //避免对上面布局造成影响
  .hr {
    border-top: 1px solid #efefef;
    width: @width-full;
    height: 0;
  }
  .bottom-link-wrapper {
    height: 214px;
    padding-top: 1em;
    width: @width-full;
    display: flex;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bottom/index.vue